"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tracker = exports.trackerAsync = exports.log = void 0;
var p_queue_1 = __importDefault(require("p-queue"));
var queue = new p_queue_1.default({ concurrency: 1 });
var wait = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};
function log(label) {
    var restOfArgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        restOfArgs[_i - 1] = arguments[_i];
    }
    // eslint-disable-next-line no-console
    console.log.apply(console, __spreadArray(["%c" + (label || '[event]'), 'border-radius: 3px; color: white; font-weight: bold; font-size: 15px; font-face: Helvetica; background-color: #00aed9; border: 1px solid #fbf2de; text-shadow: 1px 1px 4px #757989; padding: 4px 8px;'], restOfArgs));
}
exports.log = log;
var sendToClients = function (clients) {
    return clients.filter(function (x) { return !['debug', 'noPublish', 'history'].includes(x); });
};
var trackerAsync = function (configs) { return function (type, eventName, eventData, clients, props) {
    if (eventData === void 0) { eventData = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Promise.all(sendToClients(clients || Object.keys(configs)).map(function (client) { return __awaiter(void 0, void 0, void 0, function () {
                    var trackerClient, data;
                    return __generator(this, function (_a) {
                        trackerClient = configs[client] || {};
                        data = (eventData || {})[client];
                        return [2 /*return*/, trackerClient[type](eventName, data, configs.debug && log, configs.noPublish, props)];
                    });
                }); }))];
        });
    });
}; };
exports.trackerAsync = trackerAsync;
var tracker = function (configs) { return function (type, eventName, eventData, clients, props) {
    if (eventData === void 0) { eventData = {}; }
    sendToClients(clients || Object.keys(configs)).forEach(function (client) {
        var trackerClient = configs[client] || {};
        if (typeof trackerClient[type] === 'function') {
            var data_1 = (eventData || {})[client];
            queue.add(function () {
                return wait(200).then(trackerClient[type](eventName, data_1, configs.debug && log, configs.noPublish, props));
            });
        }
    });
}; };
exports.tracker = tracker;
